module.exports = __webpack_public_path__ + "media/public/img/youtube-round-01-0acef599b0341403c37127b094ecd7da.svg";